import { buildQueryString, QueryState, stringifyRequestQuery } from '.'
import { IOption, SelectValue } from '../../app/components'
import {
  getCIDs,
  getEstadosAtendimentoWithCache,
  getSituacaoesAso,
  getTiposASO,
} from '../../app/modules/apps/atendimento/core/_requests'
import { getEstadosUf } from '../../app/modules/apps/atendimento_medicos/atendimentos-medico-list/core/_requests'
import {
  getDocumentos,
  getMedicamentos,
  getModelosOfDocumentos,
} from '../../app/modules/apps/atendimento_medicos/prescricao/core/_requests'
import {
  getEmpresas,
  getEmpresasAdmin,
  getTiposEndereco,
} from '../../app/modules/apps/empresa/empresas-list/core/_requests'
import { getEmpresasCliente } from '../../app/modules/apps/empresa/empresasCliente-list/core/_request'
import { getCargosCliente } from '../../app/modules/apps/empresa/empresasClienteCargo-list/core/_request'
import { getSetoresCliente } from '../../app/modules/apps/empresa/empresasClienteSetor-list/core/_request'
import {
  getEspecialidades,
  getEspecialidadesByPaciente,
} from '../../app/modules/apps/especialidades/especialidades-list/core/_requests'
import { getFormularios } from '../../app/modules/apps/formularios/formularios-list/core/_requests'
import { RECEITUARIOS_OPTIONS } from '../../app/modules/apps/atendimento_medicos/prescricao/core/receituario'
import {
  getAnos,
  getEmpresasForFaturamento,
  getMeses,
} from '../../app/modules/apps/financeiro/atendimentos-nao-faturados/core/_requests'
import {
  getCargos,
  getCbos,
  getEspecialidadesByFuncionario,
} from '../../app/modules/apps/funcionarios/funcionarios-list/core/_requests'
import {
  getLocaisPlantoes,
  getSetoresByLocal,
  getTiposPlantao,
} from '../../app/modules/apps/pega-plantao/pega-plantao-list/core/_requests'
import { getSolicitante } from '../../app/modules/apps/relatorios/relatorio-list/core/_requests'
import {
  getTiposUnidades,
  getUnidades,
} from '../../app/modules/apps/unidades/unidades-list/core/_requests'
import { getEstadosPublic, getPessoas } from '../../app/modules/auth/core/_requests'
import {
  getEtnias,
  getFatoresDeRiscos,
  getGeneros,
  getMunicipiosPorUf,
  getPaises,
  getModalidadesAtendimento,
  getMotivosNaoRealizacao,
  getNacionalidades,
  getQuemCaiuInterrupcao,
  getRacas,
  getSituacoesFatura,
  getSituacoesNota,
  getTiposAssinaturas,
  getTiposAtendimentos,
  getTiposCategoriasNotificacao,
  getTiposContrato,
  getTiposCriterioAtendimento,
  getTiposDocumentoPessoal,
  getTiposOfFormularioSituacao,
  getTiposOfVinculo,
  getTiposSegmentosNotificacao,
  getTiposSituacoesDiagnostico,
  getTiposSituacoesInterconsulta,
  getCausasInterrupcao,
} from './crud-helper/_request'
import { AtendimentoType, ContratoType, GenderType, SituacaoAso, TarjaType } from './enums'
import {
  getConselhos,
  getProfisionaisDeSaude,
  getProfisionaisDeSaudeAdmin,
} from 'app/modules/apps/admin/profissionais-saude/profissional-saude/core/_requests'
import { getTiposAnexos } from 'app/modules/apps/admin/modelos/modelos-list/core/_requests'
import { getGrupos, getPerfis } from 'app/modules/apps/admin/grupos/grupos-list/core/_requests'
import { UsuarioDtoVinculo } from 'app/modules/apps/admin/usuarios/usuarios-list/core/_models'

const status = [
  { value: 'true', label: 'Ativo' },
  { value: 'false', label: 'Inativo' },
]

const statusCadastro = [
  { value: true, label: 'Ativo' },
  { value: false, label: 'Inativo' },
]

const booleanOptions = [
  { value: true, label: 'Sim' },
  { value: false, label: 'Não' },
]

const tiposLog = [
  { value: 1, label: 'Usuário' },
  { value: 2, label: 'Consulta' },
]

const generos = [
  { value: GenderType.Masculino, label: 'Masculino' },
  { value: GenderType.Feminino, label: 'Feminino' },
]

const receituarios = RECEITUARIOS_OPTIONS

const tarjas = [
  { value: TarjaType.Preta, label: TarjaType.Preta },
  { value: TarjaType.SemTarja, label: TarjaType.SemTarja },
  { value: TarjaType.Vermelha, label: TarjaType.Vermelha },
  { value: TarjaType.VermelhaSobRestricao, label: TarjaType.VermelhaSobRestricao },
]

const consultaDatasOptions = [
  { value: 'dataSolicitacao', label: 'Consultas agendadas entre' },
  { value: 'dataInicio', label: 'Consultas iniciadas entre' },
  { value: 'dataTermino', label: 'Consultas finalizadas entre' },
]

const getNestedValue = (obj: any, key: string): any =>
  key.split('.').reduce((acc, part) => acc && acc[part], obj)

const createOptions = <TValue = SelectValue>(
  data: unknown[],
  labelKeys: string | string[],
  valueKey: string,
  additionalKeys: string[] = []
): IOption<TValue>[] => {
  return data.map((item) => {
    if (typeof item !== 'object' || item === null) {
      return {
        label: String(item),
        value: item as TValue,
      }
    }
    const label = Array.isArray(labelKeys)
      ? labelKeys
          .map((key) => getNestedValue(item, key))
          .filter((v) => v !== undefined && v !== null && v !== '')
          .map(String)
          .join(' - ')
      : String(getNestedValue(item, labelKeys))

    const option: IOption<TValue> = {
      label,
      value: getNestedValue(item, valueKey) as TValue,
    }

    additionalKeys.forEach((key) => {
      ;(option as any)[key] = getNestedValue(item, key)
    })

    return option
  })
}

const getOptionsEmpresasForFaturamento = async (
  nomeFantasia: string,
  selectAll: boolean,
  extraParams?: { onlyActive?: boolean },
  page = 0
) => {
  const onlyActive = extraParams?.onlyActive ?? true
  const activeFilter = onlyActive ? 'ativa:true' : ''

  const search = [activeFilter, nomeFantasia ? `nomeFantasia~*${nomeFantasia}*` : '']
    .filter(Boolean)
    .join(',')

  const data = await getEmpresasForFaturamento(
    `page=${page}&size=${selectAll ? '2000' : '20'}&sort=nomeFantasia,asc${
      search ? `&search=${search}` : ''
    }`
  )

  const options = createOptions(data.data || [], 'nomeFantasia', 'id')
  return { options, hasMore: !data?.last }
}

const getOptionsEmpresas = async (
  nomeFantasia: string,
  selectAll: boolean,
  extraParams?: { onlyActive?: boolean; tipo?: AtendimentoType },
  page = 0
) => {
  const onlyActive = extraParams?.onlyActive ?? true
  const activeFilter = onlyActive ? 'ativa:true' : ''

  const tipoFilter = extraParams?.tipo ? `tiposAtendimento:${extraParams?.tipo}` : ''

  const search = [activeFilter, tipoFilter, nomeFantasia ? `nomeFantasia~*${nomeFantasia}*` : '']
    .filter(Boolean)
    .join(',')

  const data = await getEmpresas(
    `page=${page}&size=${selectAll ? '2000' : '20'}&sort=nomeFantasia,asc${
      search ? `&search=${search}` : ''
    }`
  )

  const options = createOptions(data.data || [], 'nomeFantasia', 'id')
  return { options, hasMore: !data?.last }
}

const getOptionsEmpresasAdmin = async (
  nomeFantasia: string,
  selectAll: boolean,
  extraParams?: { onlyActive?: boolean; onlySuperior?: boolean },
  page = 0
) => {
  const onlyActive = extraParams?.onlyActive ?? true
  const activeFilter = onlyActive ? 'ativa:true' : ''

  const onlySuperior = extraParams?.onlySuperior ?? false
  const superiorFilter = onlySuperior ? 'superior:null' : ''

  const search = [
    activeFilter,
    superiorFilter,
    nomeFantasia ? `nomeFantasia~*${nomeFantasia}*` : '',
  ]
    .filter(Boolean)
    .join(',')

  const data = await getEmpresasAdmin(
    `page=${page}&size=${selectAll ? '2000' : '20'}&sort=nomeFantasia,asc${
      search ? `&search=${search}` : ''
    }`
  )

  const options = createOptions(data.data || [], 'nomeFantasia', 'id')
  return { options, hasMore: !data?.last }
}

const getOptionsEstadosAtendimento = async () => {
  const data = await getEstadosAtendimentoWithCache()
  const options = createOptions(data || [], 'descricao', 'id')
  return { options, hasMore: false }
}

const getOptionsCargos = async () => {
  const data = await getCargos()
  const options = createOptions(data || [], 'descricao', 'name')
  return { options, hasMore: false }
}

const getOptionsTiposAtendimento = async () => {
  const data = await getTiposAtendimentos()
  const options = createOptions(data || [], 'descricao', 'name')
  return { options, hasMore: false, rawData: data }
}

const getOptionsFatoresRisco = async () => {
  const data = await getFatoresDeRiscos()
  const options = createOptions(data || [], 'descricao', 'name')
  return { options, hasMore: false }
}

const getOptionsDocumentos = async (
  titulo: string,
  selectAll: boolean,
  extraParams?: { onlyRetorno?: boolean },
  page = 0
) => {
  const retornoFilter = extraParams?.onlyRetorno ? 'retorno:true' : ''

  const search = ['ativo:true', retornoFilter, titulo ? `titulo~*${titulo}*` : '']
    .filter(Boolean)
    .join(',')

  const data = await getDocumentos(
    `page=${page}&size=${selectAll ? '2000' : '20'}${search ? `&search=${search}` : ''}&sort=titulo`
  )
  const options = createOptions(data.data || [], 'titulo', 'id')
  return { options, hasMore: !data?.last }
}

const getOptionsUnidades = async (
  nome: string,
  selectAll: boolean,
  extraParams?: { empresaId?: number },
  page = 0
) => {
  if (!extraParams?.empresaId) return { options: [], hasMore: false }
  const empresaFilter = extraParams?.empresaId ? `idEmpresa=${extraParams?.empresaId}&` : ''

  const search = [nome ? `nome~*${nome}*` : ''].filter(Boolean).join(',')

  const data = await getUnidades(
    `${empresaFilter}page=${page}&size=${selectAll ? '2000' : '20'}${
      search ? `&search=${search}` : ''
    }&sort=nome`
  )
  const options = createOptions(data.data || [], 'nome', 'id')
  return { options, hasMore: !data?.last }
}

const getOptionsUnidadesTodas = async (
  nome: string,
  selectAll: boolean,
  _extraParams: Record<string, any> = {},
  page = 0
) => {
  const queryParams: QueryState = {
    page,
    size: selectAll ? 2000 : 20,
    sort: 'nome',
    order: 'asc',
    search: `${nome ? `nome~*${nome}*` : ''}`,
  }
  const queryString = buildQueryString(queryParams)
  const data = await getUnidades(queryString)

  const options = createOptions(data.data || [], 'nome', 'id')
  return { options, hasMore: !data?.last }
}

const getOptionsPessoas = async (
  nome: string,
  selectAll: boolean,
  _extraParams: Record<string, any> = {},
  page = 0
) => {
  const queryParams: QueryState = {
    page,
    size: selectAll ? 2000 : 20,
    sort: 'nome',
    order: 'asc',
    search: `${nome ? `,nome~*${nome}*` : ''}`,
  }
  const queryString = buildQueryString(queryParams)
  const data = await getPessoas(queryString)

  const options = createOptions(data.data || [], 'nome', 'id')
  return { options, hasMore: !data?.last }
}

const getOptionsCategoriasNotificacao = async () => {
  const data = await getTiposCategoriasNotificacao()
  const options = createOptions(data || [], 'descricao', 'name')
  return { options, hasMore: false }
}

const getOptionsSegmentosNotificacao = async () => {
  const data = await getTiposSegmentosNotificacao()
  const options = createOptions(data || [], 'descricao', 'name')
  return { options, hasMore: false }
}

const getOptionsCriterioAtendimentoNotificacao = async () => {
  const data = await getTiposCriterioAtendimento()
  const options = createOptions(data || [], 'descricao', 'name')
  return { options, hasMore: false }
}

const getOptionsModalidadesAtendimento = async () => {
  const data = await getModalidadesAtendimento()
  const options = createOptions(data || [], 'descricao', 'name')
  return { options, hasMore: false }
}

const getOptionsSituacoesInterconsulta = async () => {
  const data = await getTiposSituacoesInterconsulta()
  const options = createOptions(data || [], 'descricao', 'name')
  return { options, hasMore: false }
}

const getOptionsSituacoesDiagnostico = async () => {
  const data = await getTiposSituacoesDiagnostico()
  const options = createOptions(data || [], 'descricao', 'name')
  return { options, hasMore: false }
}

/**
 * Opções de motivo de não realização (cancelamento e falta), derivadas do catálogo do backend.
 *
 * Ficam de fora os motivos gravados pelo próprio sistema (`sistema`) e os aposentados
 * (`ativo` falso): ambos continuam existindo para o histórico, mas não são ofertáveis em tela —
 * o servidor recusa quando um cliente tenta enviá-los.
 */
const getOptionsMotivosNaoRealizacao = async () => {
  const data = await getMotivosNaoRealizacao()
  const ofertaveis = (data || []).filter(
    (motivo) => motivo.ativo !== 'false' && motivo.sistema !== 'true'
  )
  const options = createOptions<string>(ofertaveis, 'descricao', 'name')
  return { options, hasMore: false }
}

const getOptionsCausasInterrupcao = async () => {
  const data = await getCausasInterrupcao()
  const options = createOptions<string>(data || [], 'descricao', 'name')
  return { options, hasMore: false }
}

const getOptionsQuemCaiuInterrupcao = async () => {
  const data = await getQuemCaiuInterrupcao()
  const options = createOptions<string>(data || [], 'descricao', 'name')
  return { options, hasMore: false }
}

const getOptionsTiposDocumentosPessoal = async () => {
  const data = (await getTiposDocumentoPessoal()).filter(
    (documento) => documento.cadastro === 'true'
  )
  const options = createOptions(data || [], 'descricao', 'name')
  return { options, hasMore: false }
}

const getOptionsEspecialidades = async (
  especialidade: string,
  selectAll: boolean,
  extraParams: Record<string, any> = {},
  page = 0
) => {
  const queryParams = {
    page,
    size: selectAll ? 2000 : 20,
    search: `ativa:true${especialidade ? `,nome~*${especialidade}*` : ''}`,
    ...extraParams,
  }
  const queryString = buildQueryString(queryParams)

  const data = await getEspecialidades(queryString)

  const options = createOptions(data?.data || [], 'nome', 'id')
  return { options, hasMore: !data?.last }
}

const getOptionsEspecialidadesByProfissional = async () => {
  const resp = await getEspecialidadesByFuncionario()

  const options = createOptions(resp.especialidades || [], 'nome', 'id')
  return { options, hasMore: false }
}

const getOptionsSituacoes = async () => {
  const data = await getSituacaoesAso()

  const options = createOptions(
    data.filter(
      (value) =>
        value.name === SituacaoAso.Finalizado ||
        value.name === SituacaoAso.Cancelado ||
        value.name === SituacaoAso.Gerado
    ) || [],
    'descricao',
    'name'
  )
  return { options, hasMore: false }
}

const getOptionsProfissionalSaude = async (
  nome: string,
  selectAll: boolean,
  extraParams: Record<string, any> = {},
  page = 0
) => {
  const data = await getProfisionaisDeSaude(
    `page=${page}&size=20&sort=nome,asc&search=${nome ? `,nome~*${nome}*` : ''}`
  )

  const options = createOptions(data.data || [], 'nome', 'id')
  return { options, hasMore: !data?.last }
}

const getOptionsProfissionalSaudeAdmin = async (
  nome: string,
  selectAll: boolean,
  extraParams: Record<string, any> = {},
  page = 0
) => {
  const data = await getProfisionaisDeSaudeAdmin(
    `page=${page}&size=20&sort=nome,asc&search=${nome ? `,nome~*${nome}*` : ''}`
  )

  const options = createOptions(data.data || [], 'nome', 'id')
  return { options, hasMore: !data?.last }
}

const getOptionsSolicitante = async (
  nome: string,
  selectAll: boolean,
  extraParams: Record<string, any> = {},
  page = 0
) => {
  const data = await getSolicitante(
    `page=${page}&size=20&sort=pessoa.nome,asc${nome ? `&search=pessoa.nome~*${nome}*` : ''}`
  )

  const uniqueData = Array.from(
    new Map(data?.data?.map((item) => [item.pessoa?.id, item])).values()
  )

  const options = createOptions(uniqueData || [], 'nome', 'pessoa.id')
  return { options, hasMore: !data?.last }
}

const getOptionsEstadosUf = async () => {
  const estados = await getEstadosUf()
  const options = createOptions(estados || [], 'descricao', 'sigla')
  return { options, hasMore: false }
}

const getOptionsEstadosUfPublic = async () => {
  const estados = await getEstadosPublic()
  const options = createOptions(estados || [], 'descricao', 'sigla')
  return { options, hasMore: false }
}

const getOptionsTiposEnderecos = async () => {
  const estados = await getTiposEndereco()
  const options = createOptions(estados || [], 'descricao', 'id')
  return { options, hasMore: false }
}

const getOptionsTiposContrato = async (
  _nome: string,
  _selectAll: boolean,
  extraParams?: { excludeContrato?: ContratoType },
  _page = 0
) => {
  let contratos = await getTiposContrato()

  if (extraParams?.excludeContrato)
    contratos = contratos?.filter((contrato) => contrato.name !== extraParams.excludeContrato)

  const options = createOptions(contratos || [], 'descricao', 'name')
  return { options, hasMore: false }
}

const getOptionsTiposAssinatura = async () => {
  const assinaturas = await getTiposAssinaturas()
  const options = createOptions(assinaturas || [], 'descricao', 'name')
  return { options, hasMore: false }
}

const getOptionsCids = async (
  codigo: string,
  selectAll: boolean,
  extraParams: Record<string, any> = {},
  page = 0
) => {
  const queryParams = {
    page,
    size: selectAll ? 2000 : 20,
    search: `${codigo ? `${codigo}` : ''}`,
    ...extraParams,
  }
  const queryString = buildQueryString(queryParams)
  const resp = await getCIDs(queryString)
  const options = createOptions(resp.data || [], ['codigo', 'descricao'], 'id')
  return { options, hasMore: !resp?.last }
}

const getOptionsMedicamentos = async (
  nome: string,
  selectAll: boolean,
  extraParams?: { onlyActive?: boolean; onlyLme?: boolean },
  page = 0
) => {
  const onlyActive = extraParams?.onlyActive ?? true
  const activeFilter = onlyActive ? 'ativo:true' : ''

  const onlyLme = extraParams?.onlyLme ?? false
  const lmeFilter = onlyLme ? 'lme:true' : ''

  const search = [activeFilter, lmeFilter, nome ? `nome~*${nome}*` : ''].filter(Boolean).join(',')

  const queryParams = {
    page,
    size: selectAll ? 2000 : 20,
    sort: 'nome,asc',
    search,
    ...extraParams,
  }
  const queryString = buildQueryString(queryParams)
  const resp = await getMedicamentos(queryString)
  const options = createOptions(resp.data || [], ['nome', 'concentracao', 'apresentacao'], 'id')
  return { options, hasMore: !resp?.last }
}

const getOptionsCidsByCodigo = async (
  codigo: string,
  selectAll: boolean,
  extraParams: Record<string, any> = {},
  page = 0
) => {
  const queryParams = {
    page,
    size: selectAll ? 2000 : 20,
    search: `${codigo ? `${codigo}` : ''}`,
    ...extraParams,
  }
  const queryString = buildQueryString(queryParams)
  const resp = await getCIDs(queryString)
  const options = createOptions(resp.data || [], ['codigo', 'descricao'], 'codigo')
  return { options, hasMore: !resp?.last }
}

const getOptionsSetoresClientes = async (
  nome: string,
  selectAll: boolean,
  extraParams?: { idEmpresa?: number; idCliente?: number },
  page = 0
) => {
  if (!extraParams?.idEmpresa || !extraParams.idCliente) return { options: [], hasMore: false }

  const queryParams = {
    page,
    size: selectAll ? 2000 : 20,
    search: `cliente:${extraParams.idCliente}${nome ? `,nome~*${nome}*` : ''}`,
  }

  const queryString = buildQueryString(queryParams)
  const resp = await getSetoresCliente(extraParams.idEmpresa, queryString)
  const options = createOptions(resp.data || [], 'nome', 'id')

  return { options, hasMore: !resp?.last }
}

const getOptionsCargosClientes = async (
  nome: string,
  selectAll: boolean,
  extraParams?: { idEmpresa?: number; idCliente?: number },
  page = 0
) => {
  if (!extraParams?.idEmpresa || !extraParams.idCliente) return { options: [], hasMore: false }

  const queryParams = {
    page,
    size: selectAll ? 2000 : 20,
    search: `cliente:${extraParams.idCliente}${nome ? `,nome~*${nome}*` : ''}`,
  }

  const queryString = buildQueryString(queryParams)
  const resp = await getCargosCliente(extraParams.idEmpresa, queryString)
  const options = createOptions(resp.data || [], 'nome', 'id')

  return { options, hasMore: !resp?.last }
}

const getOptionsTiposAtendimentoUsuario = (currentUser: UsuarioDtoVinculo | undefined) => {
  const tiposSet = new Set<string>()
  currentUser?.vinculos?.forEach((vinculo) => {
    if (vinculo.empresa && vinculo.empresa.tiposAtendimento) {
      vinculo.empresa.tiposAtendimento.forEach((tipo) => tiposSet.add(tipo))
    }
  })
  const options = createOptions<AtendimentoType>(
    Array.from(tiposSet).map((value) => ({ tipo: value })) || [],
    'tipo',
    'tipo'
  )
  return options
}

const getOptionsTiposAso = async () => {
  const estados = await getTiposASO()
  const options = createOptions(estados || [], 'descricao', 'name')
  return { options, hasMore: false }
}

const getOptionsEmpresasCliente = async (
  empresa: string,
  selectAll: boolean,
  extraParams: Record<string, any> = {},
  page = 0
) => {
  const queryParams = {
    page,
    size: selectAll ? 2000 : 20,
    sort: 'nome,asc',
    search: `${empresa ? `,nome~*${empresa}*` : ''}`,
    ...extraParams,
  }
  const queryString = buildQueryString(queryParams)

  const data = await getEmpresasCliente(queryString)

  const options = createOptions(data?.data || [], 'nome', 'id')
  return { options, hasMore: !data?.last }
}

const getOptionsEspecialidadesByPaciente = async (
  especialidade: string,
  selectAll: boolean,
  extraParams?: { pacienteId?: number; tipo?: AtendimentoType; unidadeId?: number },
  page = 0
) => {
  if (!extraParams?.pacienteId) return { options: [], hasMore: false }

  const query: QueryState = {
    page,
    size: selectAll ? 2000 : 20,
    search: `${especialidade ? `,nome~*${especialidade}*` : ''}`,
    filters: [
      { field: 'idUnidade', operator: '=', value: extraParams.unidadeId },
      { field: 'tipo', operator: '=', value: extraParams.tipo },
    ],
  }

  const data = await getEspecialidadesByPaciente(
    extraParams.pacienteId,
    stringifyRequestQuery(query)
  )

  const options = createOptions(data?.data || [], 'nome', 'id')
  return { options, hasMore: !data?.last }
}

const getOptionsTiposVinculos = async () => {
  const data = await getTiposOfVinculo()
  const options = createOptions(data || [], 'descricao', 'name')
  return { options, hasMore: false }
}

const getOptionsTiposUnidades = async () => {
  const data = await getTiposUnidades()
  const options = createOptions(data || [], 'nome', 'id')
  return { options, hasMore: false }
}

const getOptionsConselhos = async () => {
  const data = await getConselhos()
  const options = createOptions(data || [], ['sigla', 'nome'], 'id')
  return { options, hasMore: false }
}

const getOptionsFormularioSituacao = async () => {
  const data = await getTiposOfFormularioSituacao()
  const options = createOptions(data || [], 'descricao', 'name')
  return { options, hasMore: false }
}

const getOptionsGeneros = async () => {
  const data = await getGeneros()
  const options = createOptions(data || [], 'descricao', 'name')
  return { options, hasMore: false }
}

const getOptionsRacas = async () => {
  const data = await getRacas()
  const options = createOptions(data || [], 'descricao', 'name')
  return { options, hasMore: false }
}

const getOptionsNacionalidades = async (
  nome: string,
  selectAll: boolean,
  extraParams?: {},
  page = 0
) => {
  const queryParams: Record<string, any> = {
    page,
    size: selectAll ? 2000 : 20,
    sort: 'descricao',
  }
  const queryString = buildQueryString(queryParams)
  const resp = await getNacionalidades(queryString)
  const options = createOptions(resp?.data || [], 'descricao', 'id')
  // `rawData` para quem precisa do `codigoLedi` (1/2/3) além do id da linha — o `CustomSelect` só
  // repassa ao `onOptionsLoaded` de quem pediu, então nenhum consumidor atual muda de comportamento.
  return { options, hasMore: !resp?.last, rawData: resp?.data || [] }
}

const getOptionsEstadosUfNascimento = async () => {
  const estados = await getEstadosUf()
  const options = createOptions(estados || [], 'descricao', 'id')
  // `rawData` para quem precisa da sigla além do id — o combo de município de nascimento consulta
  // `GET /municipios/uf/{uf}`, que é por sigla, enquanto o payload de dados adicionais grava o id.
  return { options, hasMore: false, rawData: estados || [] }
}

/**
 * Municípios de nascimento (catálogo IBGE) da UF recebida em `fetchOptionsParams.uf`.
 *
 * Sem UF **não busca nada**: devolve lista vazia sem tocar na rede.
 *
 * A rota é paginada (`page`/`size`/`sort`) e o texto digitado — já debounced pelo `CustomSelect` —
 * vai como `nome` para o servidor filtrar no banco, sem acento e sem caixa. Não há mais ordenação em
 * memória: quem ordena é o `order by nome` do Postgres, cuja collation define a posição do nome
 * acentuado. Sem o filtro server-side, paginar faria o usuário deixar de encontrar município fora da
 * primeira página.
 */
const getOptionsMunicipiosPorUf = async (
  nome: string,
  selectAll: boolean,
  extraParams?: { uf?: string },
  page = 0
) => {
  const uf = extraParams?.uf
  if (!uf) return { options: [] as IOption[], hasMore: false }

  const queryParams: Record<string, any> = {
    page,
    size: selectAll ? 2000 : 20,
    sort: 'nome',
    nome,
  }
  const queryString = buildQueryString(queryParams)
  const resp = await getMunicipiosPorUf(uf, queryString)
  const options = createOptions(resp?.data || [], 'nome', 'id')
  return { options, hasMore: !resp?.last, rawData: resp?.data || [] }
}

/**
 * Países do catálogo do LEDI 8.4.2.
 *
 * Paginado e com busca server-side pelos mesmos motivos de `getOptionsMunicipiosPorUf`: a ordenação
 * vem do banco e o texto digitado vai como `nome`.
 */
const getOptionsPaises = async (nome: string, selectAll: boolean, extraParams?: {}, page = 0) => {
  const queryParams: Record<string, any> = {
    page,
    size: selectAll ? 2000 : 20,
    sort: 'nome',
    nome,
  }
  const queryString = buildQueryString(queryParams)
  const resp = await getPaises(queryString)
  const options = createOptions(resp?.data || [], 'nome', 'id')
  return { options, hasMore: !resp?.last, rawData: resp?.data || [] }
}

/** Etnias indígenas do catálogo do LEDI 8.4.2, ordenadas por nome. */
const getOptionsEtnias = async () => {
  const etnias = await getEtnias()
  const ordenadas = [...(etnias || [])].sort((a, b) =>
    (a.nome || '').localeCompare(b.nome || '', 'pt-BR')
  )
  const options = createOptions(ordenadas, 'nome', 'id')
  return { options, hasMore: false, rawData: ordenadas }
}

const getOptionsTiposAnexo = async () => {
  const tipos = await getTiposAnexos()
  const options = createOptions(tipos || [], 'descricao', 'id')
  return { options, hasMore: false }
}

const getOptionsLocaisPlantoes = async (
  nome: string,
  selectAll: boolean,
  extraParams?: { buscaSetor?: boolean },
  page = 0
) => {
  const query = extraParams?.buscaSetor ? 'buscaSetor=true' : undefined
  const locais = await getLocaisPlantoes(query)
  const options = createOptions(locais || [], 'Nome', 'CodLocal')
  return { options, hasMore: false }
}

const getOptionsSetoresPlantoes = async (
  nome: string,
  selectAll: boolean,
  extraParams?: { localId?: string },
  page = 0
) => {
  if (!extraParams?.localId) return { options: [], hasMore: false }

  const data = await getSetoresByLocal(extraParams?.localId)

  const options = createOptions(data || [], 'Nome', 'CodSetor')
  return { options, hasMore: false }
}

const getOptionsModelos = async (
  _nome: string,
  _selectAll: boolean,
  extraParams?: { idPrescricao?: number; idCid?: number }
) => {
  if (!extraParams?.idPrescricao || !extraParams?.idCid) return { options: [], hasMore: false }

  const data = await getModelosOfDocumentos(extraParams?.idPrescricao, extraParams?.idCid)

  const options = createOptions(data || [], ['titulo', 'descricao'], 'id')
  return { options, hasMore: false }
}

const getOptionsTiposPlantao = async () => {
  const tipos = await getTiposPlantao()
  const options = createOptions(tipos || [], 'Nome', 'TipoPlantaoId')
  return { options, hasMore: false, rawData: tipos }
}

const getOptionsFormularios = async (
  nome: string,
  selectAll: boolean,
  extraParams?: {},
  page = 0
) => {
  const queryParams = {
    page,
    size: selectAll ? 2000 : 20,
    search: `ativo:true,${nome ? `nome~*${nome}*` : ''}`,
  }

  const queryString = buildQueryString(queryParams)
  const resp = await getFormularios(queryString)
  const options = createOptions(resp.data || [], 'nome', 'id')

  return { options, hasMore: !resp?.last }
}

const getOptionsMeses = async () => {
  const meses = await getMeses()
  const options = createOptions(meses || [], 'descricao', 'valor')
  return { options, hasMore: false }
}

const getOptionsAnos = async () => {
  const anos = await getAnos()
  const options = createOptions(
    anos.map((v) => ({ value: v })),
    'value',
    'value'
  )
  return { options, hasMore: false }
}

const getOptionsSituacaoFatura = async () => {
  const situacoes = await getSituacoesFatura()
  const options = createOptions(situacoes || [], 'descricao', 'name')
  return { options, hasMore: false }
}

const getOptionsSituacaoNota = async () => {
  const situacoes = await getSituacoesNota()
  const options = createOptions(situacoes || [], 'descricao', 'name')
  return { options, hasMore: false }
}

const getOptionsGrupos = async () => {
  const data = await getGrupos()
  const options = createOptions(data || [], ['descricao', 'nome'], 'nome')
  return { options, hasMore: false }
}

const getOptionsPerfis = async (
  nome: string,
  selectAll: boolean,
  extraParams: Record<string, any> = {},
  page = 0
) => {
  const queryParams = {
    page,
    size: selectAll ? 2000 : 20,
    sort: 'nome,asc',
    search: `${nome ? `nome~*${nome}*` : ''}`,
    ...extraParams,
  }
  const queryString = buildQueryString(queryParams)
  const resp = await getPerfis(queryString)
  const options = createOptions(resp.data || [], ['nome', 'descricao'], 'nome')
  return { options, hasMore: !resp?.last }
}

const getOptionsCbos = async (nome: string) => {
  const data = await getCbos(nome || undefined)
  const options = createOptions(data || [], ['codigo', 'descricao'], 'codigo')
  return { options, hasMore: false }
}

export const OptionsHelper = {
  createOptions,
  status,
  booleanOptions,
  tiposLog,
  generos,
  statusCadastro,
  tarjas,
  receituarios,
  consultaDatasOptions,
  getOptionsEspecialidadesByProfissional,
  getOptionsEstadosUfPublic,
  getOptionsEmpresas,
  getOptionsEstadosUf,
  getOptionsEspecialidades,
  getOptionsFatoresRisco,
  getOptionsEstadosAtendimento,
  getOptionsTiposAtendimentoUsuario,
  getOptionsProfissionalSaude,
  getOptionsSolicitante,
  getOptionsSituacoes,
  getOptionsTiposAtendimento,
  getOptionsModalidadesAtendimento,
  getOptionsSituacoesDiagnostico,
  getOptionsSituacoesInterconsulta,
  getOptionsMotivosNaoRealizacao,
  getOptionsCausasInterrupcao,
  getOptionsQuemCaiuInterrupcao,
  getOptionsCargos,
  getOptionsTiposEnderecos,
  getOptionsTiposAso,
  getOptionsEmpresasCliente,
  getOptionsTiposContrato,
  getOptionsTiposDocumentosPessoal,
  getOptionsDocumentos,
  getOptionsCids,
  getOptionsEmpresasAdmin,
  getOptionsProfissionalSaudeAdmin,
  getOptionsUnidades,
  getOptionsEspecialidadesByPaciente,
  getOptionsTiposAssinatura,
  getOptionsTiposVinculos,
  getOptionsTiposUnidades,
  getOptionsConselhos,
  getOptionsFormularioSituacao,
  getOptionsRacas,
  getOptionsGeneros,
  getOptionsNacionalidades,
  getOptionsEstadosUfNascimento,
  getOptionsMunicipiosPorUf,
  getOptionsPaises,
  getOptionsEtnias,
  getOptionsCidsByCodigo,
  getOptionsCbos,
  getOptionsLocaisPlantoes,
  getOptionsSetoresPlantoes,
  getOptionsTiposPlantao,
  getOptionsSetoresClientes,
  getOptionsCargosClientes,
  getOptionsFormularios,
  getOptionsMeses,
  getOptionsAnos,
  getOptionsSituacaoFatura,
  getOptionsSituacaoNota,
  getOptionsEmpresasForFaturamento,
  getOptionsMedicamentos,
  getOptionsTiposAnexo,
  getOptionsModelos,
  getOptionsPerfis,
  getOptionsGrupos,
  getOptionsUnidadesTodas,
  getOptionsPessoas,
  getOptionsCategoriasNotificacao,
  getOptionsSegmentosNotificacao,
  getOptionsCriterioAtendimentoNotificacao,
}
